module.exports = __webpack_public_path__ + "static/media/13_l_Layer4_0_77.87.cc2067cd.png";